import { Component, inject } from '@angular/core';

import { ContainerComponent } from '../../../shared/components/container/container.component';
import { GlobalModalService } from '../../../shared/services/global-modal.service';

@Component({
  selector: '[cards]',
  imports: [ContainerComponent],
  templateUrl: './cards.component.html',
  styleUrl: './cards.component.scss',
})
export class CardsComponent {

  private modalService = inject(GlobalModalService);

  cards = [
    {
      color: 'purple',
      title: 'Learn the symptoms',
      text: `By knowing if you or your loved one is in the early stages of autoimmune type 1 diabetes, you can be better prepared to recognize symptoms when they appear. This can help you understand what's ahead and lower the risk of potentially life-threatening complications like diabetic ketoacidosis (DKA) with a doctor's help.`,
    },
    {
      color: 'orange',
      title: 'Prepare for what’s ahead',
      text: 'Knowing if you or your loved one has early-stage type 1 diabetes can give you time to plan ahead. Living with type 1 diabetes means taking on new responsibilities, and there is a learning curve that comes with managing it. Getting ahead of insulin dependence can help you:',
      list: [
        'develop the skills needed to manage type 1 diabetes',
        'keep up with treatment and management options your doctor can offer',
        'find the right care team and T1D support community to help',
      ],
    },
  ];


  onClick() {
    this.modalService.openModal('interstitial', 'https://www.tzield.com/')
  }

}
